import React from "react";
import { useSelector } from "react-redux";
import Translate from "helpers/Translate";

export const MiniInfoBar = () => {
  const client = useSelector(state => state.client.selectedClient);
  const fileInfo = useSelector(state => state.file.getFile);

  return (
    <div className="mini-info-bar">
      <span className="client-info">
        <strong className="client-name-label">
          {Translate({ id: "client_name" })}:&nbsp;
        </strong>
        <span className="client-name-value">
          <b>{client && client.name}</b>
        </span>
      </span>
      <span className="path-info fr">
        <span className="client-name-value">
          {(client && client.id && fileInfo && (
            <span>{fileInfo.raw_filename}</span>
          )) ||
            Translate({ id: "no_file_selected" })}
        </span>
      </span>
    </div>
  );
};
